import { IAddressSuggestion } from '../models/Account/IAddressSuggestion';

function smartStreetServiceMock() {
  function lookup(searchParam: String): Promise<any> {
    const searchResult: any = {
      suggestions: [
        {
          streetLine: '1595 1 1/2 2nd St',
          secondary: '',
          city: 'Turtle Lake',
          state: 'WI',
          zipcode: '54889',
          entries: 0,
        },
        {
          streetLine: '1595 1/2 E Vernon Ave',
          secondary: '',
          city: 'Los Angeles',
          state: 'CA',
          zipcode: '90011',
          entries: 0,
        },
        {
          streetLine: '1595 1/2 Jackson St',
          secondary: '',
          city: 'Charleston',
          state: 'WV',
          zipcode: '25311',
          entries: 0,
        },
        {
          streetLine: '1595 1/2 Midway Rd',
          secondary: '',
          city: 'Menasha',
          state: 'WI',
          zipcode: '54952',
          entries: 0,
        },
        {
          streetLine: '1595 1/2 Montrose Ter',
          secondary: '',
          city: 'Dubuque',
          state: 'IA',
          zipcode: '52001',
          entries: 0,
        },
        {
          streetLine: '1595 1/2 Old Concord Rd SE',
          secondary: '',
          city: 'Marietta',
          state: 'GA',
          zipcode: '30060',
          entries: 0,
        },
        {
          streetLine: '1595 1/2 Pacheco St',
          secondary: '',
          city: 'Santa Fe',
          state: 'NM',
          zipcode: '87505',
          entries: 0,
        },
        {
          streetLine: '159-5 95 St',
          secondary: 'Apt',
          city: 'Howard Beach',
          state: 'NY',
          zipcode: '11414',
          entries: 2,
        },
        {
          streetLine: '159-5 Calle 419',
          secondary: '',
          city: 'Carolina',
          state: 'PR',
          zipcode: '00985',
          entries: 0,
        },
        {
          streetLine: '15-951 Punawai St',
          secondary: '',
          city: 'Pahoa',
          state: 'HI',
          zipcode: '96778',
          entries: 0,
        },
      ],
    };
    return new Promise(resolve => {
      resolve(searchResult);
      throw new Error('Mock exception!');
    });
  }
  return { lookup };
}

export default smartStreetServiceMock;
